<template>
  <div class="content">
    <div class="header-box">
      <div class="left-box">
        <span>共学习</span>
        <span class="time"
          >{{ totalData.hour }}小时{{ totalData.minute }}分钟</span
        >
      </div>
      <img src="../../../assets/images/book_01.png" alt="" />
    </div>
    <div class="reader-calendar">
      <div class="top-box">
        <div class="left">
          <img src="../../../assets/images/tiem_01.png" alt="" />
          <span>{{ todayData.hour }}小时{{ todayData.minute }}分钟</span>
        </div>
        <span class="time">{{ month }}月{{ date }}日</span>
      </div>
      <vue-quick-calendar
        showPrepNext
        :startYearMonth="startYearMonth"
        :markDate="markDate"
        :checkedDate="checkedDate"
        markColor="#a2ce5f"
        activeBgColor="#5670ef"
        @clickDate="clickDate"
        @changeMonth="changeMonth"
      />
    </div>
    <div class="statistics-box">
      <div class="top-box">
        <div class="left">
          <img src="../../../assets/images/tiem_01.png" alt="" />
          <div class="">
            <span class="top">{{
              maxLearningDate ? maxLearningDate + "学习最久" : "暂无学习记录"
            }}</span>
            <span class="time"
              >学习{{ parseInt(learningDuration / 60) }}小时{{
                learningDuration % 60
              }}分钟</span
            >
          </div>
        </div>
        <div
          class="xml-switch"
          :class="halfYear ? '' : 'select-year'"
          @click="selectYear"
        >
          <div class="item-box">月</div>
          <div class="item-box year">年</div>
          <div class="slide-box"></div>
        </div>
      </div>
      <div id="main"></div>
      <div class="bottom-box">*仅显示{{ halfYear ? "半" : "六" }}年内数据</div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import vueQuickCalendar from "@/components/calendar.vue";
import {
  getReadTime,
  queryStatistics,
  queryStatisticsYear,
} from "@/api/user/learning";
export default {
  components: { vueQuickCalendar },
  data() {
    return {
      year: "1999",
      month: "01",
      date: "01",
      totalData: {
        hour: 0,
        minute: 0,
      },
      todayData: {
        hour: 0,
        minute: 0,
      },
      halfYear: true,
      data: {
        xAxisData: [],
        seriesData: [],
      },
      learningDuration: 0,
      maxLearningDate: "",
      markDate: [{ date: "2023-10-30 00:00:00" }],
      // date: '2021-01-20'
      checkedDate: "",
    };
  },

  created() {
    let month = new Date().getMonth() + 1;
    let date = new Date().getDate();
    this.year = new Date().getFullYear();
    this.month = month > 9 ? month : "0" + month;
    this.date = date > 9 ? date : "0" + date;
    this.startYearMonth = this.year + "/" + this.month + "/" + this.date;
    this.checkedDate = this.year + "/" + this.month + "/" + this.date;
    this.getUserRead("month");
    this.getYearStatistics();
  },
  mounted() {},

  methods: {
    // 点击日期
    clickDate(e) {
      this.year = e.year;
      this.month = e.month;
      this.date = e.date;
      if (e.extraInfo) {
        this.todayData.hour = e.extraInfo.hour || 0;
        this.todayData.minute = e.extraInfo.minute || 0;
      } else {
        this.todayData.hour = 0;
        this.todayData.minute = 0;
      }
    },
    // 切换月份
    changeMonth(date) {
      this.year = date.split("-")[0];
      this.month = date.split("-")[1];
      this.date = "01";
      this.checkedDate = this.year + "/" + this.month + "/" + this.date;
      this.getUserRead("month");
    },
    // 获取用户每月阅读情况
    getUserRead(type) {
      this.todayData.hour = 0;
      this.todayData.minute = 0;
      getReadTime({
        year: this.year,
        month: this.month,
      }).then((res) => {
        this.markDate = res.data.list || [];
        this.totalData.hour = res.data.hour;
        this.totalData.minute = res.data.minute;
        if (type == "month") {
          this.markDate.map((item) => {
            if (
              item.date.slice(0, 10) ==
              this.year + "-" + this.month + "-" + this.date
            ) {
              this.todayData.hour = item.hour || 0;
              this.todayData.minute = item.minute || 0;
            }
          });
        }
      });
    },
    // 切换近半年和近六年数据
    selectYear() {
      this.halfYear = !this.halfYear;
      this.getYearStatistics();
    },

    // 获取用户阅读统计
    getYearStatistics() {
      if (this.halfYear) {
        queryStatistics().then((res) => {
          let list = res.data || [];
          this.formatData(list);
        });
      } else {
        queryStatisticsYear().then((res) => {
          let list = res.data || [];
          this.formatData(list);
        });
      }
    },

    // 格式换柱状图数据
    formatData(list) {
      this.learningDuration = 0;
      let maxDate = 0;
      let xAxisData = [];
      let seriesData = [];
      list.map((item, index) => {
        let time = item.hour * 60 + item.minute;
        xAxisData.push(item.date);
        seriesData.push(time);
        this.learningDuration += time;
        if (time > maxDate) {
          maxDate = time;
          this.maxLearningDate = item.date;
        }
      });
      this.data.xAxisData = xAxisData;
      this.data.seriesData = seriesData;
      this.updateData();
      // this.option.xAxis.data = xAxisData
      // this.option.series[0].data = seriesData
    },
    updateData() {
      // setTimeout(() => {
      let chartDom = document.getElementById("main");
      let myChart = echarts.init(chartDom);
      let option = {
        xAxis: {
          type: "category",
          data: ["1", "2", "3", "4", "5", "6"],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // formatter: "{value} m",
            formatter: function (value, index) {
              var value;
              if (value < 1000) {
                value = value + "m";
              } else if (value >= 1000) {
                value = parseInt(value / 60) + "h";
              }
              return value;
            },
          },
        },
        grid: {
          left: 100,
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110],
            type: "bar",
            itemStyle: {
              barBorderRadius: [2, 2, 0, 0], //柱体圆角
              color: new echarts.graphic.LinearGradient(
                //前四个参数用于配置渐变色的起止位置，这四个参数依次对应 右下左上 四个方位。也就是从右边开始顺时针方向。
                //通过修改前4个参数，可以实现不同的渐变方向
                /*第五个参数则是一个数组，用于配置颜色的渐变过程。
									  每项为一个对象，包含offset和color两个参数
									*/
                0,
                0,
                0,
                1,
                [
                  {
                    //代表渐变色从正上方开始
                    offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                    color: "#1E63D0",
                  }, //柱图渐变色
                  {
                    offset: 1, //指100%处的颜色
                    color: "#9FE9FA",
                  },
                ]
              ),
            },
          },
        ],
      };
      option.xAxis.data = this.data.xAxisData;
      option.series[0].data = this.data.seriesData;
      option && myChart.setOption(option);
      // }, 1000)
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #f2f2f2;
  padding: 32px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  background-image: url("../../../assets/images/rader_bg_01.png");
  background-size: 900px 100%;
  background-repeat: no-repeat;
  background-position: 100px 0;

  .header-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0 0 26px;

    .left-box {
      padding: 20px 0 0 0;
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3e3e3e;

      .time {
        padding: 16px 0;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
      }
    }

    img {
      width: 114px;
    }
  }

  .reader-calendar {
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    background-color: #ffffff;

    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 38px 36px 10px 36px;

      .left {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #212121;

        img {
          width: 28px;
        }

        span {
          padding-left: 30px;
        }
      }

      .time {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #212121;
      }
    }
  }

  .statistics-box {
    position: relative;
    margin-top: 20px;
    border-radius: 16px;
    overflow: hidden;
    background-color: #ffffff;
    padding-top: 36px;

    .top-box {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 20px 36px 0 36px;

      .left {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #212121;

        img {
          width: 28px;
        }

        div {
          display: flex;
          flex-direction: column;
          padding-left: 28px;

          .top {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #838383;
          }

          .time {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #212121;
          }
        }
      }

      .xml-switch {
        position: relative;
        display: flex;
        width: 100px;
        height: 30px;
        background: #f2f2f2;
        border-radius: 15px;
        cursor: pointer;

        .item-box {
          position: relative;
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 30px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #fefefe;
        }

        .year {
          color: #333333;
        }

        .slide-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 30px;
          background: #1690ff;
          border-radius: 15px;
          transition: all 0.4s;
        }
      }

      .select-year {
        .item-box {
          color: #333;
        }

        .year {
          color: #fff;
        }

        .slide-box {
          left: 50px;
        }
      }

      .time {
        font-size: 28px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #959595;
      }
    }

    #main {
      margin-left: 100px;
      width: 880px;
      height: 400px;
      background-color: #ffffff;
    }

    .bottom-box {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 0 0 8px 0;
      text-align: right;
      font-size: 12px;
      font-family: PingFang SC-Medium, PingFang SC;
      color: #818181;
    }
  }
}
</style>